module.exports = __webpack_public_path__ + "static/biochem-sequence-7d03f0c53fa29135330ecbe132d6e3dd.png";